import { useState } from 'react'
import { Image } from '@/atoms/Image'
import { YoutubeVideoModal } from '@/molecules/YoutubeVideoModal'

export const NewTicketPromo = () => {
  const [showModal, setShowModal] = useState(false)

  const handleClick = () => setShowModal(true)
  return (
    <div className="@container">
      <div className="my-4 hidden cursor-pointer overflow-hidden rounded-xl lg:block" onClick={handleClick}>
        <Image
          className="h-full w-full"
          src={`/v1736702743/brave-the-dark/dream-vacation-banner-desk-01.png`}
          alt=""
          width={2000}
          height={334}
        />
      </div>
      <div className="my-4 hidden cursor-pointer overflow-hidden rounded-xl md:block lg:hidden" onClick={handleClick}>
        <Image
          className="h-full w-full"
          src={`/v1736702741/brave-the-dark/dream-vacation-banner-tablet-01.png`}
          alt=""
          width={2000}
          height={334}
        />
      </div>
      <div className="my-4 cursor-pointer overflow-hidden rounded-xl md:hidden" onClick={handleClick}>
        <Image
          src={`/v1736702741/brave-the-dark/dream-vacation-banner-mobile-01.png`}
          className="h-full w-full"
          alt=""
          width={856}
          height={286}
        />
      </div>
      <YoutubeVideoModal
        youTubeUrl="https://www.youtube-nocookie.com/embed/knvKDPwWo3I"
        showModal={showModal}
        handleClose={() => setShowModal(false)}
        className="!z-[60]"
      />
    </div>
  )
}
